import clsx from 'clsx';
import { FaRegStar, FaStar } from 'react-icons/fa6';

import { AuthorizedImage } from '@/components/AuthorizedImage';

import s from './BasicLayouts.module.scss';

export const BasicLayout = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <article className={clsx(s.BasicLayout, className)}>{children}</article>;
};

export const BasicLayoutNoBg = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <BasicLayout className={clsx(s.BasicLayoutNoBg, className)}>{children}</BasicLayout>;
};

export const BasicLayoutContent = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <section className={clsx(s.BasicLayoutContent, className)}>{children}</section>;
};

export const ListLayoutTileView = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <section className={clsx(s.ListLayoutTileView, className)}>{children}</section>;
};

export const ListLayoutListView = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={clsx(s.ListLayoutListViewWrapper, className)}>
      <table className={s.ListLayoutListView}>{children}</table>
    </div>
  );
};

export const ListLayoutListViewRow = ({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?(): void;
}) => {
  return (
    <tr className={clsx(onClick && s.active, className)} onClick={onClick}>
      {children}
    </tr>
  );
};

export const ListLayoutListViewImage = ({
  src,
  name,
  className,
}: {
  src?: null | string;
  name: string;
  className?: string;
}) => {
  return (
    <div className={s.ListLayoutListViewImage}>
      {src ? (
        <AuthorizedImage src={src} alt={name} />
      ) : (
        <p className={clsx(className, 'accent-large')}>{name.slice(0, 1)}</p>
      )}
    </div>
  );
};

export const ListLayoutListViewFavorite = ({
  disabled,
  favorite,
  onToggle,
  className,
}: {
  disabled: boolean;
  onToggle(): void;
  favorite: boolean;
  className?: string;
}) => {
  return (
    <button
      disabled={disabled}
      className={clsx(s.ListLayoutListViewFavorite, className)}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    >
      {favorite ? <FaStar /> : <FaRegStar />}
    </button>
  );
};
